"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAbVersion = void 0;

var getAbVersion = function getAbVersion(uuid) {
  return parseInt(uuid.match(/\d/), 10) % 2 ? 'A' : 'B';
};

exports.getAbVersion = getAbVersion;